<template>
  <!-- 碎片配置 -->
  <div class="debris_config-box">
    <!-- header头部 -->
    <header>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item>
          <el-button type="primary" @click="openDialog(1)">添加碎片</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleExport">导出</el-button>
        </el-form-item>
      </el-form>
    </header>
    <!-- body内容 -->
    <div class="body-box">
      <el-table
        :data="dataList"
        v-loading="loading"
        style="margin-bottom: 20px"
      >
        <el-table-column prop="id" label="碎片ID" align="center">
        </el-table-column>
        <el-table-column prop="image" label="碎片图片" align="center">
          <template slot-scope="{ row }">
            <img style="width: 80px" :src="row.image" alt="" />
          </template>
        </el-table-column>
        <el-table-column prop="name" label="碎片名称" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="碎片分组" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.category.name }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="num" label="碎片已生成数量" align="center">
        </el-table-column> -->
        <el-table-column
          prop="action"
          label="操作"
          align="center"
          fixed="right"
        >
          <template slot-scope="{ row }">
            <el-button type="primary" size="small" @click="openDialog(2, row)"
              >编辑</el-button
            >
            <!-- <el-button type="danger" size="small" @click="handleDelete(row)"
              >删除</el-button
            > -->
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 添加弹窗 -->
    <DebrisDialog
      v-model="dialogInfos"
      :visible="addVisible"
      :type="dialogType"
      @close="addVisible = false"
      @refresh="getData()"
    ></DebrisDialog>
  </div>
</template>
<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import http, { server, api, delApiData, getApiData, postApiData, patchApiData } from '@/http'
import saveFile from '@/utils/saveFile'
import DebrisDialog from '../../components/debrisActivity/DebrisDialog.vue'

export default {
  components: {
    DebrisDialog
  },
  data() {
    return {
      addVisible: false,//添加队伍弹窗显示标志
      loading: false,//加载动画
      groupList: undefined,//分组列表
      dataList: undefined,//数据列表
      dialogType: 1,//1是添加 2是修改 默认是1
      dialogInfos: undefined,//传给弹窗的数据
      dataMeta: undefined,//底部跳转页面条
    }
  },
  created() {
    this.getData()//获取数据列表
  },
  methods: {
    getData() {
      this.loading = true
      getApiData('debris')
        .then(res => {
          this.dataList = res.data
          //设置底部导航条数据
          this.dataMeta = res
        })
        .finally(() => {
          this.loading = false
        })
    },
    openDialog(num, val) {
      //打开添加队伍弹窗
      this.addVisible = true
      if (num === 1) {
        this.dialogType = 1
        this.dialogInfos = undefined
      }
      if (num === 2) {
        this.dialogType = 2
        let params = {
          id: val.id,
          name: val.name,
          image: val.image,
          category_id: val.category_id
        }
        this.dialogInfos = JSON.parse(JSON.stringify(params))
      }
    },
    handleDelete(row) {
      //删除
      this.$confirm('确定要删除吗？', {
        type: 'warning'
      }).then(res => {
        delApiData(`debris/${row.id}`).then(() => {
          this.$message.success('删除成功')
          this.getData()
        })
      })
    },
    handleExport() {
      http
        .get(
          api + 'debris_export',
          {
            responseType: 'arraybuffer'
          }
        )
        .then(res => {
          saveFile(res, {
            type:
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            name: '碎片表.xlsx'
          })
        }).finally(() => {
        })
    },
  }

}
</script>
<style lang="less" scoped>
</style>